import {inject, RESPONSE_INIT} from '@angular/core';
import {CanActivateChildFn, Router} from '@angular/router';
import {UserService} from '@services/user/user.service';
import {guardRedirect} from '@shared/guards/guard-redirect';

/**
 * Guard to check if the user is logged in.
 * Redirects to the guest page if the user is not authenticated.
 * For server-side rendering, sets the response status to 401 Unauthenticated.
 */
export const privateDataEnclaveAuthGuard: CanActivateChildFn = async (childRoute, _state) => {
  const router = inject(Router);
  const response = inject(RESPONSE_INIT, {optional: true});
  const userService = inject(UserService);

  const user = await userService.userPromise;

  return user ? true : guardRedirect('/pde-guest', router, response);
};
